import {
  IComboSelectBehaviorSpecifiable, instanceOfIComboSelectBehaviorSpecifiable,
  IQuestionnaireSpecifiable, instanceOfIQuestionnaireSpecifiable,
} from "../../../../documaker/domain/format/objects";
import { ISelectableObject, instanceOfISelectableObject } from "./ISelectableObject";

export interface IComboObject extends ISelectableObject, IComboSelectBehaviorSpecifiable, IQuestionnaireSpecifiable {
}

export function instanceOfIComboObject(instance: any): instance is IComboObject {
  return instance
      && instanceOfIComboSelectBehaviorSpecifiable(instance)
      && instanceOfIQuestionnaireSpecifiable(instance)
      && instanceOfISelectableObject<IComboObject>(instance, "combo");
}
